var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 20,
    viewBox: "0 0 37 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6754 20C10.869 19.7436 4.75045 16.6955 0.291107 10.5555C-0.0964622 10.0214 -0.0976089 9.89547 0.291107 9.35803C4.012 4.21188 9.02404 0.990617 15.4121 0.209194C24.3009 -0.876928 31.4274 2.27912 36.7226 9.37714C37.0965 9.8786 37.0884 10.0326 36.7226 10.5442C33.0763 15.6255 28.1281 18.6763 21.878 19.6964C20.7692 19.8774 19.6375 19.9123 18.6754 20ZM18.4988 16.0839C19.7336 16.0841 20.9408 15.7254 21.9677 15.0532C22.9947 14.381 23.7954 13.4254 24.2687 12.3071C24.742 11.1889 24.8667 9.95811 24.6269 8.7704C24.3872 7.58269 23.7938 6.49131 22.9217 5.63416C22.0496 4.77701 20.938 4.19255 19.7273 3.95463C18.5166 3.71671 17.2612 3.836 16.1196 4.29744C14.978 4.75887 14.0015 5.54174 13.3135 6.54713C12.6255 7.55252 12.2569 8.73531 12.2542 9.94606C12.2501 10.7521 12.4087 11.5509 12.721 12.2965C13.0333 13.0421 13.4929 13.7197 14.0736 14.2903C14.6542 14.8609 15.3442 15.3131 16.1039 15.621C16.8636 15.9288 17.6768 16.0861 18.4988 16.0839Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.2823627774ec171c9da89816d4d9677b.svg";
export { ForwardRef as ReactComponent };